"use strict";
// @ts-ignore
try {
    self['workbox:navigation-preload:5.1.4'] && _();
}
catch (e) { }
